import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `…/amendment/{amendmentId}/submit`。body 含 updatedAt。
 *
 * @param {string} workOrderId
 * @param {string} amendmentId
 * @param {object} [payload]
 */
export async function submitWorkOrderAmendment(
  workOrderId,
  amendmentId,
  payload = {},
) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/amendment/${amendmentId}/submit`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
